import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
import styled from "styled-components";

import {
  OptInNudgeInput,
  optInOrigin,
} from "@faire/retailer/components/Banners/OptInNudgeBanners/OptInNudgeInput";

const NudgeText: React.FC = () => {
  return (
    <>
      <Typography variant="pageHeaderSerifRegular">
        <StrictLocalMsg
          defaultMessage="Stay in the know"
          description={{
            text: "Opt-in nudge banner header text",
            img: "https://cdn.faire.com/fastly/9bf155424b3a1ccfd8db9f0abac3ff8a458272941400fcbeeba5478b3974dce9.png",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography variant="paragraphSansRegular">
        <StrictLocalMsg
          defaultMessage="Keep up with our latest offers, seasonal events, and recommendations for products we think you’ll love."
          description={{
            text: "Opt-in nudge banner body text",
            img: "https://cdn.faire.com/fastly/65e02c9b6660ae7b19bc171d51e76c532350d5ae4b35f0843f7a459da4303d67.png",
          }}
        />
      </Typography>
    </>
  );
};

export const OptInNudgeFooterBanner = () => {
  return (
    <Container>
      <NudgeText />
      <Spacer height="1x" />
      <OptInNudgeInput origin={optInOrigin.FOOTER_PAGE} />
    </Container>
  );
};

const Container = styled(Column).attrs({
  align: { mobileAndAbove: "normal", desktopAndAbove: "flex-start" },
})`
  ${responsiveMediaQueries.mobile} {
    border-top: 1px solid ${Core.surface.subdued};
    padding: ${getSpacing("3x")};
    width: 100vw;
  }
  ${responsiveMediaQueries.tablet} {
    padding: ${getSpacing("4x", "8x", "8x", 96)};
  }
  ${responsiveMediaQueries.desktopAndAbove} {
    max-width: 456px;
    padding: ${getSpacing("3x", 96, "5x", 0)};
  }
`;
